<script>
  /** @format */
  import { onMount, createEventDispatcher, afterUpdate } from 'svelte';
  import flatpickr from 'flatpickr';
  import { configItem } from 'components/Helper.js';
  import ConfirmDatePlugin from 'flatpickr/dist/plugins/confirmDate/confirmDate';
  import 'flatpickr/dist/plugins/confirmDate/confirmDate.css';
  import moment from 'moment';
  export let error;
  export let Style;
  import { getUserInfo } from '../../stores/auth';

  const hooks = new Set([
    'onChange',
    'onOpen',
    'onClose',
    'onMonthChange',
    'onYearChange',
    'onReady',
    'onValueUpdate',
    'onDayCreate',
  ]);

  export let value = '';
  export let formattedValue = '';
  export let showMonths = 1;
  export let mode = 'single';

  export let timeEnable = false;
  export let dateFormat = null;
  // export let altFormat = timeEnable?configItem.dateTimePickerFormat:configItem.datePickerFormat;
  export let altFormat = timeEnable
    ? getUserInfo().datePickerFormat + ' H:i'
    : getUserInfo().datePickerFormat;
  export let placeholder = 'Select Date';
  let allProps = $$props;

  const options = allProps.options || {};
  const props = Object.assign({}, $$props);
  delete props.options;

  let input, fp;

  $: if (fp) fp.setDate(value, false, dateFormat);
  export let pastDates = true;
  export let futureDates = true;
  export let clickOpens = true;
  export const clear = () => {
    fp.clear();
  };
  let currentAltFormat = '';
  afterUpdate(() => {
    if (currentAltFormat != altFormat) {
      fp.config.altFormat = altFormat;
      currentAltFormat = altFormat;
    }
  });
  onMount(() => {
    let plugins =
      timeEnable == false
        ? []
        : [
            new ConfirmDatePlugin({
              confirmIcon: '', // your icon's html, if you wish to override
              confirmText: 'OK ',
              showAlways: true,
              theme: 'light', // or "dark"
            }),
          ];
    const elem = input;
    fp = flatpickr(
      elem,
      {
        clickOpens: clickOpens,
        // dateFormat: configItem.datePickerFormat,
        minDate: pastDates ? '' : moment().format(configItem.momentDateFormatDB),
        maxDate: futureDates ? '' : moment().format(configItem.momentDateFormatDB),
        altInput: true,
        showMonths: showMonths,
        mode: mode,
        altFormat: altFormat,
        enableTime: timeEnable,
        dateFormat: timeEnable ? 'Y-m-d H:i' : 'Y-m-d',
        time_24hr: true,
        plugins: plugins,
      },
      {
        onChange: function (selectedDates, dateStr, instance) {
          alert('c');
        },
      },
    );

    return () => {
      fp.destroy();
    };
  });

  const dispatch = createEventDispatcher();

  $: if (fp)
    for (const [key, val] of Object.entries(addHooks(options))) {
      fp.set(key, val);
    }

  function addHooks(opts = {}) {
    opts = Object.assign({}, opts);

    for (const hook of hooks) {
      const firer = (selectedDates, dateStr, instance) => {
        if (hook == 'onOpen' && selectedDates.length == 2 && showMonths == 2) {
          if (Math.ceil(moment(selectedDates[1]).diff(selectedDates[0], 'months', true)) >= 2) {
            fp.jumpToDate(moment(selectedDates[1]).subtract(1, 'months').toDate());
          }
        }
        dispatch(stripOn(hook), [selectedDates, dateStr, instance]);
      };

      if (hook in opts) {
        // Hooks must be arrays
        if (!Array.isArray(opts[hook])) opts[hook] = [opts[hook]];

        opts[hook].push(firer);
      } else {
        opts[hook] = [firer];
      }
    }

    if (opts.onChange && !opts.onChange.includes(updateValue)) opts.onChange.push(updateValue);
    return opts;
  }

  function updateValue(newValue, dateStr) {
    value = Array.isArray(newValue) && newValue.length === 1 ? newValue[0] : newValue;
    formattedValue = dateStr;
  }

  function stripOn(hook) {
    return hook.charAt(2).toLowerCase() + hook.substring(3);
  }
</script>

<div
  class="flatpickr d-flex position-relative {error ? 'error' : ''} {Style}"
  id="my-picker"
>
  <img
    class="position-absolute img-calendar icon-16"
    alt=""
    src="/images/calendar.svg"
  />
  <input
    bind:this={input}
    {...props}
    placeholder={placeholder}
  />
  {#if error}
    <label
      class="formError"
      for={props.name}>{error}</label
    >
  {/if}
</div>

<!-- <style lang="scss">

.calendar-input{
	padding-left:25px;
  .img-calendar
  {
		  left: 10px;
		  top: 9px;
  }
}
</style>
<script>
	import flatpickr from "flatpickr";
	setTimeout(() => {
		flatpickr(".date-picker", {});
	}, 500);
	export let style;
	export let placeholder;
</script>
<div class="calendar-input select-calendar position-relative  {style}"  >
	<img class="position-absolute img-calendar icon-16" alt="" src="/images/calendar.svg"/>
	<input
			type="text"
			class="date-picker form-control add-purpose bg-transparent border-0 shadow-none border-0"
			name="example-text-input"
			placeholder={placeholder || "Select Date"} />
</div>                   -->

<style lang="scss">
  .flatpickr {
    input {
      padding-left: 33px;
    }
    .img-calendar {
      top: 9px;
      left: 10px;
    }
  }
  .form-control[readonly] {
    background: white;
    margin-right: 6px;
  }
</style>
